/* MoRetro Studio V5 — Core / Firebase / State */
window.MTS = window.MTS || {};

(function(MTS){
  "use strict";

  MTS.firebaseConfig = {
    apiKey: "AIzaSyBQkSD5zjXzEusBiNojCkfcKWiV6pe0OCI",
    authDomain: "moretro3d-avis.firebaseapp.com",
    projectId: "moretro3d-avis",
    storageBucket: "moretro3d-avis.firebasestorage.app",
    messagingSenderId: "1003541837024",
    appId: "1:1003541837024:web:17646f0ecd046524820c85",
    measurementId: "G-SFY6CDHX72"
  };

  MTS.ADMIN_EMAILS = ["morgan.duncas@gmail.com"];

  MTS.scripts = [
    "https://www.gstatic.com/firebasejs/10.12.5/firebase-app-compat.js",
    "https://www.gstatic.com/firebasejs/10.12.5/firebase-auth-compat.js",
    "https://www.gstatic.com/firebasejs/10.12.5/firebase-firestore-compat.js",
    "https://www.gstatic.com/firebasejs/10.12.5/firebase-storage-compat.js"
  ];

  MTS.state = {
    auth: null,
    db: null,
    storage: null,
    ready: null,
    reviews: [],
    projects: [],
    orders: [],
    ordersLoadedAt: null,
    selectedProjectId: null,
    activeProjectTab: "project",
    lastAutoQuote: null,
    settings: null,
    unsubReviews: null,
    unsubProjects: null
  };

  MTS.$ = function(id){ return document.getElementById(id); };
  MTS.on = function(id, eventName, handler){
    const el = MTS.$(id);
    if(el) el.addEventListener(eventName, handler);
  };
  MTS.text = function(id, value){
    const el = MTS.$(id);
    if(el) el.textContent = value;
  };
  MTS.html = function(id, value){
    const el = MTS.$(id);
    if(el) el.innerHTML = value;
  };
  MTS.hidden = function(id, value){
    const el = MTS.$(id);
    if(el) el.hidden = value;
  };

  MTS.escapeHtml = function(v){
    return String(v == null ? "" : v)
      .replaceAll("&","&amp;")
      .replaceAll("<","&lt;")
      .replaceAll(">","&gt;")
      .replaceAll('"',"&quot;")
      .replaceAll("'","&#039;");
  };

  MTS.dateLabel = function(ts){
    try { return (ts && ts.toDate ? ts.toDate() : new Date()).toLocaleString("fr-FR"); }
    catch(e){ return ""; }
  };

  MTS.millis = function(ts){
    try { return ts && ts.toMillis ? ts.toMillis() : 0; }
    catch(e){ return 0; }
  };

  MTS.money = function(v){ return (Number(v || 0)).toFixed(2).replace(".", ",") + " €"; };
  MTS.round1 = function(v){ return Number(v || 0).toFixed(1).replace(".", ","); };
  MTS.round2 = function(v){ return Number(v || 0).toFixed(2).replace(".", ","); };

  MTS.stars = function(r){
    const n = Math.max(0, Math.min(5, Number(r || 0)));
    return "★★★★★".slice(0,n) + "☆☆☆☆☆".slice(0,5-n);
  };

  MTS.statusLabel = function(status){
    const map = {
      new:"nouveau", progress:"en étude", waiting:"attente client", quoted:"devis envoyé",
      accepted:"accepté", paid:"payé", printing:"impression", finishing:"finition",
      ready:"prêt à expédier", shipped:"expédié", done:"terminé", archived:"archivé",
      pending:"en attente", published:"publié", hidden:"masqué"
    };
    return map[status || "new"] || "nouveau";
  };

  MTS.loadScript = function(src){
    return new Promise((resolve,reject)=>{
      if([].slice.call(document.scripts).some(s=>s.src===src)) return resolve();
      const s = document.createElement("script");
      s.src = src;
      s.async = true;
      s.onload = resolve;
      s.onerror = () => reject(new Error("Impossible de charger : " + src));
      document.head.appendChild(s);
    });
  };

  MTS.initFirebase = async function(){
    if(MTS.state.ready) return MTS.state.ready;

    MTS.state.ready = (async()=>{
      for(const src of MTS.scripts) await MTS.loadScript(src);

      if(!window.firebase) throw new Error("Firebase n'est pas chargé.");
      if(!firebase.apps.length) firebase.initializeApp(MTS.firebaseConfig);

      MTS.state.auth = firebase.auth();
      MTS.state.db = firebase.firestore();
      MTS.state.storage = firebase.storage();

      return MTS.state;
    })();

    return MTS.state.ready;
  };

  MTS.setError = function(msg){
    const el = MTS.$("mtsError");
    if(!el) return;
    el.textContent = msg || "";
    el.hidden = !msg;
  };

  MTS.isAdmin = function(user){
    return user && MTS.ADMIN_EMAILS.includes(String(user.email || "").toLowerCase());
  };

  MTS.showLogin = function(){
    MTS.hidden("mtsLogin", false);
    MTS.hidden("mtsApp", true);

    if(MTS.state.unsubReviews){
      MTS.state.unsubReviews();
      MTS.state.unsubReviews = null;
    }

    if(MTS.state.unsubProjects){
      MTS.state.unsubProjects();
      MTS.state.unsubProjects = null;
    }
  };

  MTS.showApp = function(user){
    MTS.hidden("mtsLogin", true);
    MTS.hidden("mtsApp", false);
    MTS.text("mtsWelcome", (user && user.displayName ? user.displayName.split(" ")[0] : "Morgan") + " 👋");

    MTS.Reviews.listen();
    MTS.Projects.listen();
  };

  MTS.googleLogin = async function(){
    const btn = MTS.$("mtsGoogleLogin");
    MTS.setError("");
    if(btn) btn.disabled = true;

    try{
      await MTS.initFirebase();
      const provider = new firebase.auth.GoogleAuthProvider();
      provider.setCustomParameters({prompt:"select_account"});
      await MTS.state.auth.signInWithPopup(provider);
    }catch(e){
      MTS.setError(e && e.code === "auth/popup-blocked"
        ? "Popup bloquée. Autorise les popups puis réessaie."
        : "Connexion refusée. Vérifie Firebase Authentication.");
      console.error(e);
    }finally{
      if(btn) btn.disabled = false;
    }
  };

})(window.MTS);
